/* eslint max-classes-per-file: "off" */
import { transitionEndEventName } from './utility';

class Accordion {
  constructor(buttonElement, bodyElement) {
    this.$button = $(buttonElement);
    this.$body = $(bodyElement);
    this.isAnimate = false;
    this.storeHeight = null;
  }

  active() {
    if (
      (this.$button.hasClass('_close') && this.$body.hasClass('_open')) ||
      (this.$button.hasClass('_open') && this.$body.hasClass('_close'))
    ) {
      this.$button.toggleClass('_open _close');
    }
    this.$body.css('display', this.$button.hasClass('_open') ? 'flex' : '');

    this.$body.on(`${transitionEndEventName.event}.accordion`, () => {
      if (this.$button.hasClass('_close')) {
        this.$body.css('display', '');
      }
      this.$body.css('height', '');
      this.isAnimate = false;
    });

    this.$button.on('click.accordion', event => {
      let elementHeight;

      event.preventDefault();

      if (this.isAnimate) {
        this.$body[0].style.height = this.$button.hasClass('_close')
          ? `${this.storeHeight}px`
          : 0;
      } else {
        if (this.$button.hasClass('_close')) {
          this.$body.css('display', 'flex');
          elementHeight = this.$body[0].getBoundingClientRect().height;
          this.$body[0].style.height = 0;
          // eslint-disable-next-line no-unused-expressions
          this.$body[0].offsetHeight; // reflow
          this.$body[0].style.height = `${elementHeight}px`;
        } else {
          elementHeight = this.$body[0].getBoundingClientRect().height;
          this.$body[0].style.height = `${elementHeight}px`;
          // eslint-disable-next-line no-unused-expressions
          this.$body[0].offsetHeight; // reflow
          this.$body[0].style.height = 0;
        }
        this.storeHeight = elementHeight;
      }
      this.$button.toggleClass('_open _close');
      this.$body.toggleClass('_open _close');
      this.isAnimate = true;
    });
  }

  inactive() {
    this.$button.off('click.accordion');
    this.$body.off(`${transitionEndEventName.event}.accordion`);
    if (this.$button.hasClass('_open')) {
      this.$button.toggleClass('_open _close');
      this.$body.toggleClass('_open _close');
    }
    this.$body.css({
      display: '',
      height: '',
    });
    this.isAnimate = false;
  }
}

class Tab {
  constructor() {
    this.$tab = $('.p-tab01');
    this.$tabNav = this.$tab.find('.p-tab01nav__item');
    this.$tabContentsWrapper = this.$tab.find('.p-tab01contentsWrapper');
    this.$tabContents = this.$tab.find('.p-tab01contents');
    this.isEnabled =
      this.$tabNav.length !== 0 && this.$tabContents.length !== 0;
  }

  changeActiveNav(index) {
    this.$tabNav.eq(index).addClass('_current');
    this.$tabNav.not(`:eq(${index})`).removeClass('_current');
  }

  changeActiveContent(index, isAnimate) {
    const activeIndex = this.$tabNav.index(this.$tabNav.filter('._current'));
    const startHeight = this.$tabContents.eq(activeIndex).outerHeight();

    if (isAnimate) {
      this.$tabContentsWrapper.css('height', `${startHeight}px`);
    }

    this.$tabContents
      .eq(index)
      .addClass('_open')
      .removeClass('_close');
    this.$tabContents
      .not(`:eq(${index})`)
      .addClass('_close')
      .removeClass('_open');

    if (isAnimate) {
      const endHeight = this.$tabContents.eq(index).outerHeight();

      if (startHeight === endHeight) {
        this.$tabContentsWrapper.css('height', '');
      } else {
        // eslint-disable-next-line no-unused-expressions
        this.$tabContentsWrapper.offsetHeight; // reflow
        this.$tabContentsWrapper.css('height', `${endHeight}px`);
      }
    }
  }

  active() {
    if (!this.isEnabled) return;

    this.$tabContentsWrapper.on(
      `${transitionEndEventName.event}.tab`,
      event => {
        if (event.currentTarget === event.target) {
          this.$tabContentsWrapper.css('height', '');
        }
      },
    );

    this.changeActiveContent(
      this.$tabNav.index(this.$tabNav.filter('._current')),
      false,
    );

    this.$tabNav.on('click.tab', event => {
      const index = this.$tabNav.index(event.currentTarget);

      event.preventDefault();
      this.changeActiveContent(index, true);
      this.changeActiveNav(index);
    });
  }

  inactive() {
    if (!this.isEnabled) return;

    this.$tabContentsWrapper.off(`${transitionEndEventName.event}.tab`);
    this.$tabNav.off('click.tab');
  }
}

export default function tab01() {
  const mqlMenu = window.matchMedia('screen and (max-width: 980px)');
  const tab = new Tab();
  const accordionItems = [];

  $('.p-tab01')
    .find('.p-tab01__titleMenu')
    .filter((index, element) => {
      return $(element).next('.p-tab01contents').length === 1;
    })
    .each((index, element) => {
      accordionItems.push(new Accordion(element, $(element).next()[0]));
    });

  function checkBreakPoint(mql) {
    if (mql.matches) {
      tab.inactive();
      accordionItems.forEach(element => {
        element.active();
      });
    } else {
      accordionItems.forEach(element => {
        element.inactive();
      });
      tab.active();
    }
  }
  mqlMenu.addListener(checkBreakPoint);
  checkBreakPoint(mqlMenu);
}
